import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchHomeData = createAsyncThunk("homePage/fetchHomeData", async ({ lang = "en" }) => {
  const response = await axios.post(
    "https://milkys.bytesway.io/api/home",
    {
      lang,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data.data;
});

const homePageSlice = createSlice({
  name: "homePage",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHomeData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHomeData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchHomeData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default homePageSlice.reducer;
